<template>
  <ul class="Sidebar p-3 flex-shrink-0" :class="{opened: value}">
    <span
      class="toggler"
      :class="{toggled: value}"

      @click.stop="$emit('input', !value)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 48 48">
        <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
          <path d="M6.46.5,12.6,6.65a.48.48,0,0,1,0,.7L6.46,13.5" style="fill: none;stroke: #000000;stroke-linecap: round;stroke-linejoin: round"></path>
          <path d="M1.25.5,7.4,6.65a.5.5,0,0,1,0,.7L1.25,13.5" style="fill: none;stroke: #000000;stroke-linecap: round;stroke-linejoin: round"></path>
        </g></g>
      </svg>
    </span>
  
    <li v-for="(item, index) in computedSteps"
      :key="item.id"

      :class="{
        active: item.active,
        error: errors.includes(index),
      }"
      class="d-flex align-items-center justify-content-between"

      @click="select(index)"
    >
      <span>
        <span class="icon mr-2">
          <slot :name="`icon-${item.id}`"></slot>
        </span>

        <span class="name">
          {{ item.name }}
        </span>

        <span v-if="errors.includes(index)" class="error-icon">
          <svg width="16" height="16" fill="none" stroke="var(--red)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
        </span>
      </span>
    </li>

    <slot name="below-sections"></slot>
  </ul>
</template>

<script>

export default {
  props: {
    value: Boolean,
    steps: {
      type: Array,
      required: true,
    },
    errors: Array,
    activeStep: String,
  },
  methods: {
    select(index) {
      this.$emit("click-on-el")
      this.$emit("select", index)
    },
  },
  computed: {
    computedSteps() {
      const active = this.activeStep

      return this.steps.map((item, index) => ({
        ...item,

        active: active === item.id,
      }))
    },
  },
}

</script>

<style>

@media (max-width: 640px) {
  .Sidebar {
    flex-basis: 30px;
    padding-left: 10px !important;
    padding-right: 7px !important;
    padding-top: 26px !important;
  }
}

</style>

<style scoped>

.Sidebar {
  position: relative;
  flex-basis: 210px;
  border-right: 1px solid var(--black-20);
  padding-top: 30px !important;
  margin: 0;
  background-color: #FBFBFB;
  min-width: 250px;
}

li, .icon {
  transition-duration: .1s;
}

li {
  position: relative;
  list-style: none;
  cursor: pointer;
  white-space: nowrap;
}

li + li {
  margin-top: 16px;
}

.icon {
  position: relative;
  transform: translateY(-1.5px);
  color: var(--black-20);
}

.line {
  position: absolute;
  width: 2px;
  height: 14px;
  left: 50%;
  top: 100%;
  margin-top: 5px;
  transform: translateX(-50%);
  border-radius: 1px;
  background-color: #D1D3D4;
}

li:hover {
  font-weight: 600;
}

.error, .error .icon {
  color: var(--red) !important;
}

li:hover, li.active, li:hover .icon, li.active .icon {
  color: var(--mint-green) !important;
}

.Sidebar, .icon {
  color: #212529;
  font-weight: 600;
}

.error-icon {
  display: block;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.toggler {
  display: none;
  transform: rotate(0deg);
  transition-duration: .15s;
}

.toggled {
  transform: rotate(180deg);
}

@media (max-width: 1270px) {
  .Sidebar {
    flex-basis: 175px;
  }
}

@media (max-width: 640px) {
  .Sidebar {
    transition-duration: .15s;
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 36px;
    padding-left: 8.5px !important;
    padding-right: 7px !important;
    padding-top: 45px !important;
    z-index: 200;
    overflow: hidden;
  }

  .toggler {
    position: absolute;
    display: block;
    top: 0px;
    margin-top: 9px;
    margin-left: 3px;
  }

  .opened {
    width: 175px;
  }
}


</style>
